import React from 'react';
import { Box } from '@material-ui/core';
import styles from './styles';

type Props = {
  value: string,
};

const Type: React.FC<Props> = props => {
  const { value } = props;
  const statusColor: string = value.toLowerCase();
  let lockType: string;
  if (styles[statusColor]) {
    lockType = statusColor;
  } else {
    lockType = 'other';
  }

  return (
    <Box component="span" color={styles[lockType].color}>
      {value}
    </Box>
  );
};

export default Type;
